import React from 'react';
import GetStartedHero from './GetStartedHero';
import GetStartedForm from './GetStartedForm';
import Footer from '../../Footer';

const GetStartedPage = () => {
  return (
    <div className="get-started-page-container">
      <GetStartedHero />
      <GetStartedForm />
      <Footer showGetStarted={false}/>
    </div>
  );
};

export default GetStartedPage;